"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var customUnits = ['dollars', 'percent'];
var customTypes = ['fee', 'discount', 'test_fee', 'test_discount'];
/**
 * @class
 * @param {String} params.key - Should match a preset, if applicable
 * @param {String} params.customType - one of 'fee' or 'discount'
 * @param {Number} params.customValue - dollar amount or percent (e.g. 10.00 or 4.854) (absolute value)
 * @param {String} params.customLabel - what to call the discount/fee (e.g. 'Import Fee')
 * @param {String} params.customUnits - one of 'dollars' or 'percent'
 * @property {String} units
 * @property {Number} value
 * @property {String} label
 * @property {String} type
 */

var PriceAdjustment = /*#__PURE__*/function () {
  function PriceAdjustment() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PriceAdjustment);

    this.key = params.key || null;
    this.customType = params.customType || 'fee';
    this.customValue = params.customValue ? Math.abs(parseFloat(params.customValue, 10)) : null;
    this.customLabel = params.customLabel || null;
    this.customUnits = params.customUnits && customUnits.includes(params.customUnits) ? params.customUnits : null; // this.value = params.value || null;
    // this.units = params.units || null;
    // this.label = params.label || null;
    // this.promo_code = params.promo_code || null;
  }

  _createClass(PriceAdjustment, [{
    key: "units",
    get: function get() {
      if (this.key) {
        return this.PRICE_ADJUSTMENTS[this.key].units;
      }

      if (this.customUnits && !customUnits.includes(this.customUnits)) {
        throw new Error("units must be one of [".concat(customUnits.join(' | '), "]"));
      }

      return this.customUnits;
    },
    set: function set(u) {
      if (!customUnits.includes(u)) {
        throw new Error("units must be one of [".concat(customUnits.join(' | '), "], received ").concat(u));
      }

      this.customUnits = u;
    }
  }, {
    key: "type",
    get: function get() {
      if (this.key) {
        return this.PRICE_ADJUSTMENTS[this.key].type;
      }

      return this.customType;
    },
    set: function set(t) {
      if (!customTypes.includes(t)) {
        throw new Error("type must be one of [".concat(customTypes.join(' | '), "], received ").concat(t));
      }

      this.customType = t;
    }
  }, {
    key: "value",
    get: function get() {
      var returnValue = 0;
      var type = this.type;

      if (this.key) {
        returnValue = Math.abs(this.PRICE_ADJUSTMENTS[this.key].value);
      } else {
        returnValue = Math.abs(this.customValue);
      }

      if (type.match(/discount/)) {
        return -1 * returnValue;
      }

      return returnValue;
    },
    set: function set(v) {
      if (Number.isNaN(parseInt(v, 10))) {
        throw new Error("value must be an integer, got ".concat(v));
      }

      this.customValue = Math.abs(v);
    }
  }, {
    key: "label",
    get: function get() {
      if (this.key) {
        return this.PRICE_ADJUSTMENTS[this.key].label;
      }

      return this.customLabel;
    },
    set: function set(l) {
      if (!l) {
        throw new Error('label must be at least one character in length');
      }

      this.customLabel = l;
    }
  }]);

  return PriceAdjustment;
}(); // this.PRICE_ADJUSTMENTS are presets defined in ShineOrdersConfig.json
// and assigned in ShineOrders.initialize()


PriceAdjustment.prototype.PRICE_ADJUSTMENTS = [];
module.exports = PriceAdjustment;